
export class AudioCache {
  private cache: Map<string, string>;
  private blobCache: Map<string, Blob>;

  constructor() {
    this.cache = new Map();
    this.blobCache = new Map();
  }

  async set(cacheKey: string, audioBlob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        if (typeof reader.result === 'string') {
          this.cache.set(cacheKey, reader.result);
          this.blobCache.set(cacheKey, audioBlob);
          resolve(reader.result);
        } else {
          reject('Failed to read blob as data URL');
        }
      };
      reader.onerror = () => {
        reject(reader.error);
      };
      reader.readAsDataURL(audioBlob);
    });
  }

  async get(cacheKey: string): Promise<string | null> {
    return this.cache.get(cacheKey) || null;
  }

  async getBlob(cacheKey: string): Promise<Blob | undefined> {
    return this.blobCache.get(cacheKey);
  }

  invalidate(cacheKey: string): void {
    this.cache.delete(cacheKey);
    this.blobCache.delete(cacheKey);
  }

  clear(): void {
    this.cache.clear();
    this.blobCache.clear();
  }

  generateCacheKey(text: string, voice: string, language?: string): string {
    // Include language in cache key to separate different language versions
    const combined = text + voice + (language || 'english');
    let hash = 0;
    for (let i = 0; i < combined.length; i++) {
      hash = ((hash << 5) - hash) + combined.charCodeAt(i);
      hash &= hash;
    }
    return `audio_${Math.abs(hash)}_${voice}_${language || 'english'}`;
  }
}

export const audioCache = new AudioCache();
